import React from 'react';

export const Toolbar = props => {
    return(
        <div className="fn-buttons">
            {props.children}
        </div>
    )
}